import React from 'react';
import './NavBar.css';
// (Optional) Import component styles. If you are using Less, import the `index.less` file. 
import 'rsuite/styles/index.less'; // or 'rsuite/dist/rsuite.min.css'
import 'rsuite/Sidenav/styles/index.css';
import 'rsuite/Nav/styles/index.css';
// import logo from '../../Images/EASALY_color_horiz-SendGrid.png';
import { Link } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AdfScannerIcon from '@mui/icons-material/AdfScanner';
import BackupTableIcon from '@mui/icons-material/BackupTable';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import GroupIcon from '@mui/icons-material/Group';
import Tooltip from '@mui/material/Tooltip';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import { InterestsOutlined, ReviewsOutlined, RefreshOutlined } from '@mui/icons-material';
import Redo from '@mui/icons-material/Redo';
import NextPlan from '@mui/icons-material/NextPlan';
import Delete from '@mui/icons-material/Delete';
import Subscription from '@mui/icons-material/Subscriptions';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Reviews from '@mui/icons-material/ReviewsOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';




interface NavBarLeftProps { }
interface NavBarLeftState {
    expanded: boolean;
    activeKey: string;
    activeUrl: string;
    isToggled: boolean;
    logo: string;
    tenantIndex: number;
}

class NavBarLeft extends React.Component<NavBarLeftProps, NavBarLeftState> {
    constructor(props_: NavBarLeftProps) {
        super(props_);

        this.state = {
            expanded: true,
            activeKey: "1",
            activeUrl: '',
            isToggled: true,
            logo: '',
            tenantIndex: 1
        }

        window.addEventListener("popstate", () => {
            this.setState({
                activeUrl: window.location.pathname
            });
        });
    }

    async componentDidMount() {
        const tenantData = JSON.parse(localStorage.getItem('TENANT_CONFIG') || '{}');
        const smallLogo = tenantData?.assets?.find(
            (x: string) => x.indexOf('admin_main_logo_small.png') !== -1
        );
        const tenantIndex = tenantData?.tenant_index;
        if (smallLogo) {
            this.setState({
                logo: smallLogo,
                tenantIndex: tenantIndex
            });
        }
    }


    public render() {
        return (
            <div className={`nav-container ` + (this.state.isToggled ? 'active' : '')}>
                <div className='menu-toggle' onClick={() => {
                    this.setState({
                        isToggled: !this.state.isToggled
                    });
                }}>{
                        this.state.isToggled ? <KeyboardArrowRightIcon fontSize='large' /> : <KeyboardArrowLeftIcon fontSize='large' />}</div>
                <div className='logo-container' style={{
                    width: '100%',
                    height: '50px',
                    padding: '30px 0px'
                }}>
                    <div style={{
                        backgroundImage: `url(${this.state.logo})`,
                        width: '100%',
                        height: '60px',
                        backgroundSize: '230px',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '-5px 6px'
                    }}>
                        {/* <img src={logo} alt="Logo" className="app-logo" /> */}
                    </div>
                    {/* <div className='app-title'>EASALY AI</div> */}
                </div>
                <div className='menu-container'>
                    {/* <Tooltip title="Form Details"><Link to="/form8821" className={this.isSelected('form8821')} onClick={() => { this.setActiveUrl('form8821') }}><div className='menu-item'><AdfScannerIcon /> <span>Form Details</span></div></Link></Tooltip> */}
                    <Tooltip title="User Details"><Link to="/userProgress" className={this.isSelected('userProgress')} onClick={() => { this.setActiveUrl('userProgress') }}><div className='menu-item'><AdfScannerIcon /> <span>User Details</span></div></Link></Tooltip>
                    {/* <Tooltip title="Transaction Logs"><Link to="/transactionlogs" className={this.isSelected('transactionlogs')} onClick={() => { this.setActiveUrl('transactionlogs') }}><div className='menu-item'><BackupTableIcon /> <span>Transaction Logs</span></div></Link></Tooltip> */}
                    {/* <Tooltip title="User Actions"><Link to="/useractions" className={this.isSelected('useractions')} onClick={() => { this.setActiveUrl('useractions') }}><div className='menu-item'><GroupIcon /> <span>User Actions</span></div></Link></Tooltip> */}
                    <Tooltip title="Dashboard"><Link to="/dashboard" className={this.isSelected('dashboard')} onClick={() => { this.setActiveUrl('dashboard') }}><div className='menu-item'><WorkHistoryIcon /> <span>Dashboard</span></div></Link></Tooltip>
                    {/* Case Dashboard */}
                    {this.state.tenantIndex != 2 && (
                        <>
                            <Tooltip title="Case Dashboard"><Link to="/casedashboard" className={this.isSelected('casedashboard')} onClick={() => { this.setActiveUrl('casedashboard') }}><div className='menu-item'><DashboardOutlinedIcon /> <span>Case Dashboard</span></div></Link></Tooltip>
                            <Tooltip title="Form 433-A Review"><Link to="/form433AReview" className={this.isSelected('form433AReview')} onClick={() => { this.setActiveUrl('form433AReview') }}><div className='menu-item'><FactCheckOutlinedIcon /> <span>Form 433-A Review</span></div></Link></Tooltip>
                        </>
                    )}
                    {/* <Tooltip title="Kwong Claim"><Link to="/kwongClaims" className={this.isSelected('kwongClaims')} onClick={() => { this.setActiveUrl('kwongClaims') }}><div className='menu-item'><RefreshOutlined /> <span>Kwong Claim</span></div></Link></Tooltip> */}
                    <Tooltip title="Kwong Claim"><Link to="/kwongClaimsDetails" className={this.isSelected('kwongClaimsDetails')} onClick={() => { this.setActiveUrl('kwongClaimsDetails') }}><div className='menu-item'><RefreshOutlined /> <span>Kwong Claim</span></div></Link></Tooltip>
                    {this.state.tenantIndex != 2 && (
                        <>
                            <Tooltip title="CSED Calculator"><Link to="/chatGpt/pdfUpload" className={this.isSelected('chatGpt/pdfUpload')} onClick={() => { this.setActiveUrl('chatGpt/pdfUpload') }}><div className='menu-item'><BackupTableIcon /> <span>CSED Calculator</span></div></Link></Tooltip>
                            <Tooltip title="IRS Interest Details"><Link to="/interestDetails" className={this.isSelected('interestDetails')} onClick={() => { this.setActiveUrl('interestDetails') }}><div className='menu-item'><InterestsOutlined /> <span>IRS Interest Details</span></div></Link></Tooltip>
                            <Tooltip title="Review Payment Forms"><Link to="/reviewPayment" className={this.isSelected('reviewPayment')} onClick={() => { this.setActiveUrl('reviewPayment') }}><div className='menu-item'><ReviewsOutlined /> <span>Review Payment Forms</span></div></Link></Tooltip>

                            <Tooltip title="Expense Validation"><Link to="/expenseValidation" className={this.isSelected('expenseValidation')} onClick={() => { this.setActiveUrl('expenseValidation') }}><div className='menu-item'><AssuredWorkloadIcon /> <span>Expense Validation</span></div></Link></Tooltip>
                            {/* <Tooltip title="All Eligible plans"><Link to="/getAllEligiblePlans" className={this.isSelected('getAllEligiblePlans')} onClick={() => { this.setActiveUrl('getAllEligiblePlans') }}><div className='menu-item'><NextPlan/> <span>Eligible plans</span></div></Link></Tooltip> */}
                            <Tooltip title="Review Expense Proofs"><Link to="/reviewProofs" className={this.isSelected('reviewProofs')} onClick={() => { this.setActiveUrl('reviewProofs') }}><div className='menu-item'><NextPlan /> <span>Review Expense Proofs</span></div></Link></Tooltip>
                            <Tooltip title="Invalidate Form 8821"><Link to="/invalidate" className={this.isSelected('invalidate')} onClick={() => { this.setActiveUrl('invalidate') }}><div className='menu-item'><Delete /> <span>Invalidate Form</span></div></Link></Tooltip>
                            <Tooltip title="Subscriptions List"><Link to="/SubscriptionList" className={this.isSelected('SubscriptionList')} onClick={() => { this.setActiveUrl('SubscriptionList') }}><div className='menu-item'><Subscription /> <span>Subscriptions List</span></div></Link></Tooltip>
                            <Tooltip title="Support Tickets"><Link to="/supportTickets" className={this.isSelected('supportTickets')} onClick={() => { this.setActiveUrl('supportTickets') }}><div className='menu-item'><SupportAgentIcon /> <span>Support Tickets</span></div></Link></Tooltip>
                            <Tooltip title="User Loan Rejection"><Link to="/userLoanRejection" className={this.isSelected('userLoanRejection')} onClick={() => { this.setActiveUrl('userLoanRejection') }}><div className='menu-item'><MoneyOffIcon /> <span>User Loan Rejection</span></div></Link></Tooltip>
                            <Tooltip title="Rejected Users"><Link to="/rejectedUsers" className={this.isSelected('rejectedUsers')} onClick={() => { this.setActiveUrl('rejectedUsers') }}><div className='menu-item'><Redo /> <span>Rejected Users</span></div></Link></Tooltip>
                        </>
                    )
                    }
                    {/* <Tooltip title="Revenue Details"><Link to="/revenueDetails" className={this.isSelected('revenueDetails')} onClick={() => { this.setActiveUrl('revenueDetails') }}><div className='menu-item'><AttachMoneyIcon /> <span>Revenue Details</span></div></Link></Tooltip> */}
                </div>
                {/* <div>
                    <div style={{
                            display: 'inline-block',
                            float: 'inline-end'
                    }}>
                        <Link to="#" onClick={() => {
                            this.setState({
                                activeUrl: ''
                            }, () => {
                                localStorage.clear();
                                window.location.href = '/';
                            })

                        }}><div className='menu-item log-out'><LogoutIcon /> <span>Sign Out</span></div></Link>
                    </div>

                </div> */}


                {/* <Toggle
                    onChange={(value) => {
                        console.log(value);
                        this.setState({
                            expanded: value
                        })
                    }}
                    checked={this.state.expanded}
                    checkedChildren="Expand"
                    unCheckedChildren="Collapse"
                />
                <hr />
                <Sidenav expanded={this.state.expanded} defaultOpenKeys={['3', '4']}>
                    <Sidenav.Body>
                        <Nav activeKey={this.state.activeKey} onSelect={(key) => {
                            this.setState({
                                activeKey: key
                            })
                        }}>
                            <Nav.Item eventKey="1" icon={<DashboardIcon />}>
                                Dashboard
                            </Nav.Item>
                            <Nav.Item eventKey="2" icon={<GroupIcon />}>
                                User Group
                            </Nav.Item>
                            <Nav.Menu placement="rightStart" eventKey="3" title="Advanced" icon={<MagicIcon />}>
                                <Nav.Item eventKey="3-1">Geo</Nav.Item>
                                <Nav.Item eventKey="3-2">Devices</Nav.Item>
                                <Nav.Item eventKey="3-3">Loyalty</Nav.Item>
                                <Nav.Item eventKey="3-4">Visit Depth</Nav.Item>
                            </Nav.Menu>
                            <Nav.Menu
                                placement="rightStart"
                                eventKey="4"
                                title="Settings"
                                icon={<GearCircleIcon />}
                            >
                                <Nav.Item eventKey="4-1">Applications</Nav.Item>
                                <Nav.Item eventKey="4-2">Channels</Nav.Item>
                                <Nav.Item eventKey="4-3">Versions</Nav.Item>
                                <Nav.Menu eventKey="4-5" title="Custom Action">
                                    <Nav.Item eventKey="4-5-1">Action Name</Nav.Item>
                                    <Nav.Item eventKey="4-5-2">Action Params</Nav.Item>
                                </Nav.Menu>
                            </Nav.Menu>
                        </Nav>
                    </Sidenav.Body>
                    <Sidenav.Toggle onToggle={expanded => this.setState({
                        expanded: expanded
                    })} />
                </Sidenav> */}
            </div >
        )
    }

    private setActiveUrl(url: string) {
        this.setState({
            activeUrl: url
        })
    }

    private isSelected(screenName: string) {
        var url_ = window.location.href.replace(window.location.origin, '').replace('#', '');

        console.log(url_);

        return url_.indexOf(`/${screenName}`) != -1 ? 'selected' : '';
    }
}

export default NavBarLeft;